import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40e1634c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-mb-[30px]" }
const _hoisted_2 = { class: "tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold" }
const _hoisted_3 = { style: {"background-color":"white"} }
const _hoisted_4 = { class: "tw-p-[15px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-t-md" }
const _hoisted_5 = { class: "tw-p-[15px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-b-md" }
const _hoisted_6 = { class: "tw-mb-[30px]" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold" }, /*#__PURE__*/_toDisplayString("Attributes"), -1))
const _hoisted_8 = { style: {"background-color":"white"} }
const _hoisted_9 = { class: "tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-t-md" }
const _hoisted_10 = { class: "tw-flex-1" }
const _hoisted_11 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_12 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_13 = { class: "tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]" }
const _hoisted_14 = { class: "tw-flex-1" }
const _hoisted_15 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_16 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_17 = { class: "tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]" }
const _hoisted_18 = { class: "tw-flex-1" }
const _hoisted_19 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_20 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_21 = {
  class: "tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]",
  style: {"border-bottom-left-radius":"6px","border-bottom-right-radius":"6px"}
}
const _hoisted_22 = { class: "tw-flex-1" }
const _hoisted_23 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_24 = { class: "dropdown-container tw-flex-1 dropdown" }

import {
  ASSESSMENT_ANSWER_STORE_TYPE,
  CHECKLIST_ICON_VALUE_WITH_COLOR,
} from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import { computed, onMounted, ref, Ref } from "vue";
import PercentInput from "../common/percentInput.vue";
import store from "@/store";
import CustomBDropDown from "@/components/common/customBDropDown.vue";
import Effort from "@/components/svgs/effort.vue";
import CustomBDropDownItem from "@/components/common/customBDropDownItem.vue";
import Impact from "@/components/svgs/impact.vue";
import Importance from "@/components/svgs/importance.vue";
import Cost from "@/components/svgs/cost.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";

const inputLabelGray = "!tw-text-[#878787] tw-text-[13px] tw-font-normal";
const inputLabelBlack = "!tw-text-[#231F20] tw-text-[13px] tw-font-normal";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentBulkAnswerQuestions',
  props: {
  handleUpdateData: {
    type: Function,
    default: () => {},
  },
},
  setup(__props) {

const props = __props;



const checklistItemComplianceOverrideValue = ref("0.8");
const checklistItemCompensatingControlValue = ref("");
const defaultOverrideClass = computed(() => {
  const numOverride = parseFloat(checklistItemComplianceOverrideValue.value);
  const numControl = parseFloat(checklistItemCompensatingControlValue.value);
  return numControl > 0 || numOverride === 0 ? inputLabelGray : inputLabelBlack;
});
const defaultControlClass = computed(() => {
  const numControl = parseFloat(checklistItemCompensatingControlValue.value);
  return numControl === 0 ? inputLabelGray : inputLabelBlack;
});

const importanceRef: Ref<IDropDownData[]> = ref([]);
const costRef: Ref<IDropDownData[]> = ref([]);
const impactRef: Ref<IDropDownData[]> = ref([]);
const effortRef: Ref<IDropDownData[]> = ref([]);

let classImportanceName = ref("");
let classCostName = ref("");
let classImpactName = ref("");
let classEffortName = ref("");

const importanceDropdownData: any = computed(
  () => store.state.Assessment.importanceAssessment,
);
const impactDropdownData: any = computed(
  () => store.state.Assessment.impactAssessment,
);
const effortDropdownData: any = computed(
  () => store.state.Assessment.effortAssessment,
);
const costDropdownData: any = computed(
  () => store.state.Assessment.costAssessment,
);

onMounted(() => initialData());

const initialData = () => {
  props.handleUpdateData({
    [ASSESSMENT_ANSWER_STORE_TYPE.COMPLIANCE_OVERRIDE]:
      checklistItemComplianceOverrideValue.value,
    [ASSESSMENT_ANSWER_STORE_TYPE.COMPENSATING_CONTROL]:
      checklistItemCompensatingControlValue.value,
  });
  handleImportanceSelected({
    id: "vh",
    name: "Very High",
  });
  handleImpactSelected({
    id: "vh",
    name: "Very High",
  });
  handleCostSelected({
    id: "m",
    name: "Medium",
  });
  handleEffortSelected({
    id: "l",
    name: "Low",
  });
};
const handleImportanceSelected = (event: IDropDownData) => {
  importanceRef.value = [event];
  classImportanceName.value = event.id
    ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  props.handleUpdateData({
    [ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_IMPORTANCE]: event.id,
  });
};

const handleImpactSelected = (event: IDropDownData) => {
  impactRef.value = [event];
  classImpactName.value = event.id
    ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  props.handleUpdateData({
    [ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_IMPACT]: event.id,
  });
};

const handleCostSelected = (event: IDropDownData) => {
  costRef.value = [event];
  classCostName.value = event.id
    ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  props.handleUpdateData({
    [ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_COST]: event.id,
  });
};

const handleEffortSelected = (event: IDropDownData) => {
  effortRef.value = [event];
  classEffortName.value = event.id
    ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  props.handleUpdateData({
    [ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_EFFORT]: event.id,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(getComponentUiText)("app-component-assessments-override-title-1")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(PercentInput, {
            value: checklistItemComplianceOverrideValue.value,
            "data-cy-id": "assessment-bulk-answer-compliance-override-value",
            "hint-text": "%",
            label: 
            'Compliance Override' ||
            _unref(getComponentUiText)(
              'app-component-assessments-question-type-2-override-label-1',
            )
          ,
            "is-in-range100": true,
            "class-text": defaultOverrideClass.value,
            "class-input": '!tw-min-w-[50px] md:!tw-min-w-[80px] !tw-min-h-[44px] tw-text-[13px] tw-font-normal !tw-bg-[rgba(239,240,241,0.5)]',
            "onOn:blur": _cache[0] || (_cache[0] = 
            () => {
              __props.handleUpdateData({
                [_unref(ASSESSMENT_ANSWER_STORE_TYPE).COMPLIANCE_OVERRIDE]:
                  checklistItemComplianceOverrideValue.value,
              });
            }
          ),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = 
            (value) => {
              checklistItemComplianceOverrideValue.value = (
                parseFloat(value) / 100 || 0
              ).toFixed(2);
            }
          )
          }, null, 8, ["value", "label", "class-text", "class-input"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(PercentInput, {
            value: checklistItemCompensatingControlValue.value,
            "data-cy-id": "assessment-bulk-answer-compensating-value",
            "hint-text": "%",
            "is-in-range100": true,
            "class-text": defaultControlClass.value,
            label: 
            _unref(getComponentUiText)(
              'app-component-assessments-question-type-2-compensating-controls-label-1',
            )
          ,
            "class-input": '!tw-min-w-[50px] md:!tw-min-w-[80px] !tw-min-h-[44px] tw-text-[13px] tw-font-normal !tw-bg-[rgba(239,240,241,0.5)]',
            "onOn:blur": _cache[2] || (_cache[2] = 
            () => {
              __props.handleUpdateData({
                [_unref(ASSESSMENT_ANSWER_STORE_TYPE).COMPENSATING_CONTROL]:
                  checklistItemCompensatingControlValue.value,
              });
            }
          ),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = 
            (value) => {
              checklistItemCompensatingControlValue.value = (
                parseFloat(value) / 100 || 0
              ).toFixed(2);
            }
          )
          }, null, 8, ["value", "class-text", "label", "class-input"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Importance, {
              class: _normalizeClass([
              'info-icon',
              'Cost',
              'tw-text-[#231F20]',
              'tw-scale-[0.856]',
              'tw-mr-[10px]',
            ])
            }),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(getComponentUiText)("app-component-table-header-importance-1")), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(CustomBDropDown, {
              id: 'importanceOption',
              data: importanceRef.value,
              "class-text-name": `${_unref(classImportanceName)}`,
              "class-name": 
              'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
              'white-background'
            ,
              placeholder: 
              _unref(getComponentUiText)(
                'app-component-assessments-assessment-question-chose-answer-prompt-1',
              )
            
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(importanceDropdownData.value, (item, index) => {
                  return (_openBlock(), _createBlock(CustomBDropDownItem, {
                    key: index,
                    data: item,
                    "class-name": `normal-dropdown-container ${
                item.id
                  ? `${_unref(CHECKLIST_ICON_VALUE_WITH_COLOR)[`${item.id}`]}`
                  : 'tw-text-[#231F20]'
              }`,
                    onClick: ($event: any) => (handleImportanceSelected(item))
                  }, null, 8, ["data", "class-name", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "class-text-name", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(Impact, {
              class: _normalizeClass([
              'info-icon',
              'Cost',
              'tw-text-[#231F20]',
              'tw-scale-[0.856]',
              'tw-mr-[10px]',
            ])
            }),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-question-type-2-icon-tooltip-impact-1",
            )), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(CustomBDropDown, {
              id: 'impactOption',
              data: impactRef.value,
              "class-text-name": `${_unref(classImpactName)}`,
              "class-name": 
              'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
              'white-background'
            ,
              placeholder: 
              _unref(getComponentUiText)(
                'app-component-assessments-assessment-question-chose-answer-prompt-1',
              )
            
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(impactDropdownData.value, (item, index) => {
                  return (_openBlock(), _createBlock(CustomBDropDownItem, {
                    key: index,
                    data: item,
                    "class-name": `normal-dropdown-container ${
                item.id
                  ? `${_unref(CHECKLIST_ICON_VALUE_WITH_COLOR)[`${item.id}`]}`
                  : 'tw-text-[#231F20]'
              }`,
                    onClick: ($event: any) => (handleImpactSelected(item))
                  }, null, 8, ["data", "class-name", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "class-text-name", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(Cost, {
              class: _normalizeClass([
              'info-icon',
              'Cost',
              'tw-text-[#231F20]',
              'tw-scale-[0.856]',
              'tw-mr-[10px]',
            ])
            }),
            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-question-type-2-icon-tooltip-cost-1",
            )), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(CustomBDropDown, {
              id: 'costOption',
              data: costRef.value,
              "class-text-name": `${_unref(classCostName)}`,
              "class-name": 
              'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
              'white-background'
            ,
              placeholder: 
              _unref(getComponentUiText)(
                'app-component-assessments-assessment-question-chose-answer-prompt-1',
              )
            
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(costDropdownData.value, (item, index) => {
                  return (_openBlock(), _createBlock(CustomBDropDownItem, {
                    key: index,
                    data: item,
                    "class-name": `normal-dropdown-container ${
                item.id
                  ? `${_unref(CHECKLIST_ICON_VALUE_WITH_COLOR)[`${item.id}`]}`
                  : 'tw-text-[#231F20]'
              }`,
                    onClick: ($event: any) => (handleCostSelected(item))
                  }, null, 8, ["data", "class-name", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "class-text-name", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(Effort, {
              class: _normalizeClass([
              'info-icon',
              'Cost',
              'tw-text-[#231F20]',
              'tw-scale-[0.856]',
              'tw-mr-[10px]',
            ])
            }),
            _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-question-type-2-icon-tooltip-effort-1",
            )), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(CustomBDropDown, {
              id: 'effortOption',
              data: effortRef.value,
              "class-text-name": `${_unref(classEffortName)}`,
              "class-name": 
              'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
              'white-background'
            ,
              placeholder: 
              _unref(getComponentUiText)(
                'app-component-assessments-assessment-question-chose-answer-prompt-1',
              )
            
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(effortDropdownData.value, (item, index) => {
                  return (_openBlock(), _createBlock(CustomBDropDownItem, {
                    key: index,
                    data: item,
                    "class-name": `normal-dropdown-container ${
                item.id
                  ? `${_unref(CHECKLIST_ICON_VALUE_WITH_COLOR)[`${item.id}`]}`
                  : 'tw-text-[#231F20]'
              }`,
                    onClick: ($event: any) => (handleEffortSelected(item))
                  }, null, 8, ["data", "class-name", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "class-text-name", "placeholder"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})